const middleware = ({ store }) => {
    if (store.state.damagesValuation.productLines !== null) {
        return;
    }
    return store.dispatch('damagesValuation/fetchProductLines');
};
export default middleware;
